import images from "./images";

const sampleUsers = [
  {
    id: 1,
    name: "User1",
    img: images.user1,
  },

  {
    id: 2,
    name: "User2",
    img: images.user2,
  },

  {
    id: 3,
    name: "User3",
    img: images.user3,
  },

  {
    id: 4,
    name: "User4",
    img: images.user4,
  },
];

export default {sampleUsers};